// extracted by mini-css-extract-plugin
export default {"main":"q9mxe1XBWQH4Gb4o6Hgi","message":"d66dwJKIoAtmRAsbVi4O"};